import React, { Component } from "react";
import { graphql } from "react-apollo";
import {
  queryGetServerTime,
  queryGetMe,
  queryGetCompanyConfiguration,
  subsOnCaseAdded,
  subsOnCaseUpdated,
  subsOnStreamAdded,
  subsOnStreamUpdated,
  subsOnSchedulerPostAdded,
  subsOnSchedulerPostUpdated,
  subsOnNotificationAdded,
  GetNoNeedLabelId
} from "Apollo";
import {
  CaseManagementStore,
  CommonStore,
  UpdateServerTime,
  TickServerTime,
  SelectCase,
  ServiceAlertStore,
  IsAgentAllowedToAssignToOther,
  ChangeTab,
  TabName
} from "Store";
import { AddPostFromSubs } from "../module-schedule/store";

// Component to sync when case added subscription triggered
const CaseAddedSubs = graphql(subsOnCaseAdded)(
  class extends Component {
    componentWillReceiveProps({
      data: {
        data: { onCaseAdded: newCase }
      }
    }) {
      CaseManagementStore.subsCases.set(newCase.id.toString(), newCase);
    }

    render() {
      return null;
    }
  }
);

// Component to sync when case updated subscription triggered
const CaseUpdatedSubs = graphql(subsOnCaseUpdated)(
  class extends Component {
    componentWillReceiveProps({
      data: {
        data: { onCaseUpdated: newCase }
      }
    }) {
      const store = CaseManagementStore;
      store.subsCases.set(newCase.id.toString(), newCase);

      // update selected case if any
      if (store.selectedCase && store.selectedCase.id === newCase.id) {
        SelectCase(newCase);        
      }
    }

    render() {
      return null;
    }
  }
);

const NotifAddedSubs = graphql(subsOnNotificationAdded)(
  class extends Component {
    componentWillReceiveProps({
      data: {
        data: { onNotificationAdded: notificationValue }
      }
    }) {
      if (notificationValue) {
        if (notificationValue.notificationGroup.length !== 0) {
          let store = ServiceAlertStore.currentState;
          const idAgent = notificationValue.agent.id;
          store.case = [];
          notificationValue.notificationGroup.map(row => {
            if (idAgent === row.assignedTo) {
              store.case.push({
                id: row.id,
                caseId: row.caseId,
                username: row.channelHandlerUsername,
                content: row.content
              });
              store.message = store.case[0].content;
            }
          });
          store.isShown = store.case.length > 0 ? true : false;
          store.count = store.case.length;
        }
      }
    }
    render() {
      return null;
    }
  }
);

// helper function to add or update new stream
export function pushNewStream(newStream) {
  const caseId = newStream.caseId.toString();
  const store = CaseManagementStore;

  // try to get previous stream on case
  let streams = store.subsStreams.get(caseId);
  if (!streams) streams = new Map();

  // add the new stream
  streams.set(newStream.id.toString(), newStream);
  store.subsStreams.set(caseId, streams);
}

// Component to sync when strem added subscription triggered
const StreamAddedSubs = graphql(subsOnStreamAdded)(
  class extends Component {
    componentWillReceiveProps({
      data: {
        data: { onStreamAdded: newStream }
      }
    }) {
      pushNewStream(newStream);
    }

    render() {
      return null;
    }
  }
);

// Component to sync when stream updated subscription triggered
const StreamUpdatedSubs = graphql(subsOnStreamUpdated)(
  class extends Component {
    componentWillReceiveProps({
      data: {
        data: { onStreamUpdated: newStream }
      }
    }) {
      pushNewStream(newStream);
    }

    render() {
      return null;
    }
  }
);

const SchedulerPostAddedSubs = graphql(subsOnSchedulerPostAdded)(
  class extends Component {
    componentWillReceiveProps({
      data: {
        data: { onSchedulerPostAdded: newPost }
      }
    }) {
      AddPostFromSubs(newPost);
    }

    render() {
      return null;
    }
  }
);

const SchedulerPostUpdatedSubs = graphql(subsOnSchedulerPostUpdated)(
  class extends Component {
    componentWillReceiveProps({
      data: {
        data: { onSchedulerPostUpdated: newPost }
      }
    }) {
      AddPostFromSubs(newPost);
    }

    render() {
      return null;
    }
  }
);

const MeSync = graphql(queryGetMe)(
  class MeSyncInternal extends Component {
    componentWillReceiveProps({ data: { me } }) {
      if (me) {
        CommonStore.me = me;
        if(!IsAgentAllowedToAssignToOther()) {
          ChangeTab(TabName.MY)
        }
      }
    }

    render() {
      return null;
    }
  }
);

const CompanyConfigSync = graphql(queryGetCompanyConfiguration)(
  class CompanyConfigSyncInternal extends Component {
    componentWillReceiveProps({ data: { getCompanyConfiguration: config } }) {
      if (config) {
        CommonStore.responseTimeSLA = config.responseTimeSLA;
        CommonStore.replyLabelActive = config.replyLabelActive;
        CommonStore.nickActive = config.nickActive;
        CommonStore.channelSignatureActive = config.iconCompanyActive;
        CommonStore.autoAssignActive = config.autoAssignActive;
        CommonStore.csatActive = config.csatActive;
        CommonStore.workingStart = config.workingStart;
        CommonStore.workingEnd = config.workingEnd;
        CommonStore.allowAgentAssignToOther = config.allowAgentAssignToOther       
        CommonStore.enableTicketing = config.enableTicketing 
        CommonStore.enableEmailCampaign = config.enableEmailCampaign
        CommonStore.enableBulkSms = config.enableBulkSms
        CommonStore.moduleLoaded = true
        CommonStore.allowDisableUnassignCase = config.allowDisableUnassignCase
      }
    }

    render() {
      return null;
    }
  }
);

const ServerTimeSync = graphql(queryGetServerTime, {
  options: {
    // sync server time per 5 minutes
    pollInterval: 300000,
    fetchPolicy: "network-only"
  }
})(
  class ServerTimeSyncInternal extends Component {
    componentWillReceiveProps({ data: { getServerTime: serverTime } }) {
      if (serverTime) UpdateServerTime(serverTime);
    }

    componentDidMount() {
      // start continuous time update locally
      this.interval = setInterval(() => TickServerTime(30), 30000);
    }

    componentWillUnmount() {
      clearInterval(this.interval);
    }

    render() {
      return null;
    }
  }
);

export default class ServerSync extends Component {
  async componentDidMount() {
    CommonStore.noNeedId = await GetNoNeedLabelId();
  }

  render() {
    return [
      <MeSync key="me" />,
      // <CompanyConfigSync key="config" />,
      <ServerTimeSync key="servertime" />,
      <CaseAddedSubs key="caseAddedSubs" />,
      <CaseUpdatedSubs key="caseUpdatedSubs" />,
      <StreamAddedSubs key="streamAddedSubs" />,
      <StreamUpdatedSubs key="streamUpdatedSubs" />,
      <SchedulerPostAddedSubs key="schedulerPostAddedSubs" />,
      <SchedulerPostUpdatedSubs key="schedulerPostUpdatedSubs" />,
      <NotifAddedSubs key="notificationAddedSubs" />
    ];
  }
}



// WEBPACK FOOTER //
// ./src/module-common/ServerSyncWithStoreQuerySubs.js